import Text from '../../../atoms/Text';
import Button from '../../../molecules/Button';

import './styles.scss';

interface IStatusModalProps {
  title: string;
  subtitle: string;
  description: string;
  icon: string;
  iconColor: string;
  buttonText: string;
  onSubmit: () => Promise<void> | void;
}

const StatusModal = ({
  title,
  subtitle,
  description,
  icon,
  iconColor,
  buttonText,
  onSubmit,
}: IStatusModalProps) => {
  return (
    <>
      <div className='edit_profile_modal'>
        <div className='edit_profile_modal__header'>
          <Text size={16}>{title}</Text>
        </div>
        <div className='edit_profile_modal__body' style={{ height: 'auto' }}>
          <div
            className={`payment_modal__icon ${icon}`}
            style={{ color: iconColor }}
          />
          <div className='payment_modal__text'>
            <Text size={12}>{subtitle}</Text>
            <Text size={12}>{description}</Text>
          </div>
        </div>
        <div className='payment_modal__btn'>
          <Button
            size='m'
            variant='primary'
            action={onSubmit}
            text={buttonText}
          />
        </div>
      </div>
      <div className='edit_profile_modal__backdrop' />
    </>
  );
};

export default StatusModal;
